import { render, staticRenderFns } from "./SGPTabelaComponent.vue?vue&type=template&id=0829cd4c"
import script from "./SGPTabelaComponent.vue?vue&type=script&lang=js"
export * from "./SGPTabelaComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTabelaComponent.vue?vue&type=style&index=0&id=0829cd4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports